<template>
    <div class="page bgF6F6F6">

        <div style="height: 46px; line-height: 46px;">
            <header class="pageHeader detailPageHeader paddingH16 white_bg">
                <div class="borderLayout">
                    <div class="middleRegion">
                        <div class="westRegion" style="width: 60px">
                            <span class="icon leftAngleBracketIcon floatL" style="margin-top: 12px;" @click="back();"></span>
                        </div>
                        <div class="centerRegion alignCenter font18r primaryTextColor bold">
                            {{title}}
                        </div>
                        <div class="eastRegion font14r alignRight" style="width: 60px"></div>
                    </div>
                </div>
            </header>
        </div>

        <div class="body">
            <div class="">

                <div class="formRow clearfix">
                    <div class="columnName">个人认证</div>
                    <router-link to="/me/myProfile" class="columnValue">
                        {{dataItem ? dataItem.userName : ''}}
                        <i class="fa fa-angle-right"></i>
                    </router-link>
                </div>

                <div class="formRow clearfix">
                    <div class="columnName">账号与安全</div>
                    <router-link to="/me/account" class="block columnValue">
                        <i class="fa fa-angle-right"></i>
                    </router-link>
                </div>


                <div class="formRow clearfix">
                    <div class="columnName">版本</div>
                    <div class="columnValue">
                        {{appConfig.version}}
                    </div>
                </div>

                <div class="formRow clearfix" style="margin-bottom: 13px;" v-if="debugStatus">
                    <div class="columnName">分销状态</div>
                    <div class="block columnValue">
                        {{ getPromotionStatus() }}
                    </div>
                </div>

                <div class="formRow clearfix">
                    <div class="alignC font14r" style="color: #101010;" @click="logout()">
                        退出
                    </div>
                </div>

            </div>
        </div><!-- end .body -->

    </div>
</template>

<script>
import shixunPagePart from '@/components/shixunApp/shixunPagePart';

// config
import appConfig from '@/appConfig';
import externalApp from '@/data/externalApp';
import userApi from '@/api/user';

// util
import appHelper    from '@/util/appHelper';
import consoleApi from "@comp/platformApi/consoleApi";
import consoleHelper from "@util/consoleHelper";
import cookieHelper from "js-cookie";

const config = {
    name : 'setting',
    title : '设置',
    description : '',
    apiConfig : {
        get : {
            url : 'portal/v4/user/center/getUserInfo'
        },
    }
};

export default {
    name: config.name,
    extends : shixunPagePart,
    components : {  },
    data () {
        return {
            title : config.title,
            description : config.description,
            apiConfig : config.apiConfig,

            enableDataItem : true,
            autoLoadDataItem : true,
            appConfig : appConfig,

            debugStatus : consoleHelper.getDebugStatus()
        }
    },
    methods : {
        aboutUs() {
            appHelper.redirect(externalApp.oldShixun.baseUrl + 'html/me/about.html');
        },
        logout() {
            userApi.logout(() => {
                appHelper.showHint('成功退出');
                appHelper.goToPage('index');
            });
        },
        getPromotionStatus() {
            let promotion_from = cookieHelper.get('promotion_from') || '';
            let msg = '';
            if (promotion_from)
            {
                msg = '分销邀请码（' + promotion_from + '）';
            }
            else
            {
                msg = '无';
            }

            return msg;
        }
    }
}
</script>

<style lang="scss" scoped>
.grey {
    color: #9D9E9D;
}
.formRow {
    padding: 12px 10px;
    background: white;
    border-bottom: solid 1px #ebebeb;
    .columnName {
        float: left;
        width: 50%;
        color: #5B616C;
    }
    .columnValue {
        float: right;
        width: 50%;
        font-size: 14px;
        text-align: right;
        color: #9D9E9D;
    }
}
</style>
